import { NOTIFICATION_TYPE } from '../../../../constants/common'

import {
  DUPLICATE_FILE_INITIAL_NOTIFICATION,
  FOLDER_NAME,
} from './useDocumentsTableActions.constants'

export function getEditInitialValues(item) {
  return {
    [FOLDER_NAME]: item.name,
  }
}

export function getParent(id, items) {
  return items?.find(item => String(item.id) === String(id))
}

export function getDuplicateModalInitialNotifications(t) {
  return [
    {
      id: DUPLICATE_FILE_INITIAL_NOTIFICATION,
      text: t('Notification.InfoSelectFolderToDuplicateKey'),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}
